import { render } from "./CoteChip.vue?vue&type=template&id=56d17a74&scoped=true"
import script from "./CoteChip.vue?vue&type=script&lang=js"
export * from "./CoteChip.vue?vue&type=script&lang=js"

import "./CoteChip.vue?vue&type=style&index=0&id=56d17a74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d17a74"]])

export default __exports__